import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

export const navbarStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
            color: '#575756',
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        logo: {
            height: "100px",
            width: '100%',
            color: 'inherit',
            fill: 'currentColor',
            stroke: 'currentColor',
            overflow: 'visible',
        },
        mainLogo: {
            textAlign: 'center',
            color: 'white',
            backgroundColor: '#E2000F',
            height: '72px',
            width: '104px',
            position: 'absolute',
            left: '0',
        },
        mainToolbar: {
            backgroundColor: '#575756',
        },
        userButton: {
            marginLeft: '10px', 
            textTransform: 'none', 
            fontWeight: 'bold', 
            color:'#fff',
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        }
    }),
);